import script from "./CrudAsistentes.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudAsistentes.vue?vue&type=script&setup=true&lang=js"

import "./CrudAsistentes.vue?vue&type=style&index=0&id=61d1c248&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61d1c248"]])

export default __exports__